module.exports = __webpack_public_path__ + "static/media/peace.78319e26.jpg";